import { h } from 'preact';
import { getHTMLFromMarkdown } from 'widget_main/components/Markdown/helpers';
import styles from './markdown.scss';

interface MarkdownProps {
  markdown: string;
  options?: marked.MarkedOptions;
  formatHtml?: (html: string) => string;
}

const Markdown = ({
  markdown,
  options,
  formatHtml = (html) => html,
}: MarkdownProps) => {
  const html = getHTMLFromMarkdown(markdown, options);

  return (
    <div
      className={styles.markdownBody}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: formatHtml(html) }}
    />
  );
};

export default Markdown;
